import { SvgIconProps } from "@mui/material";

// 3 panes stacked on the left, 1 pane spanning the full height on the right.
export const ThreePlusOneVerticalIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="6" rx="1.2" />
    <rect x="2" y="9" width="9" height="6" rx="1.2" />
    <rect x="2" y="16" width="9" height="6" rx="1.2" />
    <rect x="13" y="2" width="9" height="20" rx="1.5" />
  </svg>
);
